import request from "@/plugins/request"

export const checkPwd = (data) => {
  return request({
    url: "app-api/member/auth/check",
    method: "post",
    data,
  })
}
export const sendCode = (data) => {
  return request({
    url: "app-api/member/auth/send-code",
    method: "post",
    data,
  })
}
export const codeLogin = (data) => {
  return request({
    url: "app-api/member/auth/code-login",
    method: "post",
    data,
  })
}
export const passwordLogin = (data) => {
  return request({
    url: "app-api/member/auth/login",
    method: "post",
    data,
  })
}
